import { render } from "./serveurdevices.vue?vue&type=template&id=1725b686&scoped=true"
import script from "./serveurdevices.vue?vue&type=script&lang=js"
export * from "./serveurdevices.vue?vue&type=script&lang=js"

import "./serveurdevices.vue?vue&type=style&index=0&id=1725b686&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1725b686"]])

export default __exports__